import { render, staticRenderFns } from "./commonPopup.vue?vue&type=template&id=3a9d83ed&scoped=true&"
import script from "./commonPopup.vue?vue&type=script&lang=js&"
export * from "./commonPopup.vue?vue&type=script&lang=js&"
import style0 from "./commonPopup.vue?vue&type=style&index=0&id=3a9d83ed&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a9d83ed",
  null
  
)

export default component.exports